export default __webpack_public_path__ + "static/media/Mask Group 11@2x.0291c01c.png";